import { render, staticRenderFns } from "./RealEstateDocumentsDialog.vue?vue&type=template&id=bb78e7d6&scoped=true"
import script from "./RealEstateDocumentsDialog.vue?vue&type=script&lang=ts"
export * from "./RealEstateDocumentsDialog.vue?vue&type=script&lang=ts"
import style0 from "./RealEstateDocumentsDialog.vue?vue&type=style&index=0&id=bb78e7d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb78e7d6",
  null
  
)

export default component.exports